<template>
  <div v-if="isAuthenticated && stockType != 3">
    <div v-if="hasVariations" class="flex items-end gap-1.5">
      <div class="pb-0.5 text-14 lg:text-xs">
        {{ $t("common.suffixes.from") }}
      </div>
      <VcPriceDisplayCatalog :value="value?.actual" class="text-xl font-bold" />
    </div>
    <div v-else-if="value?.list?.amount! > value?.actual?.amount!" class="flex flex-wrap items-end gap-1.5">
      <VcPriceDisplayCatalog :class="priceColorClass" :value="value?.actual" class="font-inter text-xl font-bold" />
      <VcPriceDisplayCatalog
        v-if="promotionActive"
        :value="value?.list"
        class="mb-px pb-0.5 text-xs font-semibold"
        is-old-price
      />
    </div>
    <div v-else class="flex flex-wrap items-end gap-1.5">
      <VcPriceDisplayCatalog :class="priceColorClass" :value="value?.list" class="font-inter text-xl font-bold" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useUser } from "@/shared/account";
import type { MoneyType, PriceType, Property } from "@/core/api/graphql/types";

interface IProps {
  value?: PriceType | { list: MoneyType; actual: MoneyType };
  hasVariations?: boolean;
  priceColorClass?: string;
  properties: Property[] | undefined;
  stockType?: number;
}

const props = withDefaults(defineProps<IProps>(), {
  priceColorClass: "text-[color:var(--color-price-current)]",
});

const { isAuthenticated } = useUser();

const promotionActiveProperty = "promotionactive_property";
const promotionActive = computed<boolean>(
  () => props.properties?.filter((item: Property) => item.name === promotionActiveProperty)[0].value === true,
);
</script>
